import { Input } from '@eika/input';
import { useTranslation } from '@translations';
import { isEmptyEmail, validEmail } from '@utils/email-validate-utils';
import { useState } from 'react';
import './email-input.scss';

interface EmailInputProps {
    setValue: (a: string) => void;
}

export const EmailInput = ({ setValue }: EmailInputProps) => {
    const { processSummary } = useTranslation();
    const [emailInputValue, setEmailInputValue] = useState('');
    const [formError, setFormError] = useState<string | undefined>(undefined);

    const handleOnChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        setFormError(undefined);

        setEmailInputValue(target.value);
        setValue(target.value);
    };

    const handleOnBlur = (_e: React.FocusEvent<HTMLInputElement, Element>) => {
        setFormError(undefined);

        if (isEmptyEmail(emailInputValue)) {
            setFormError(processSummary.email.emptyEmailError);
            return;
        }

        if (!validEmail(emailInputValue)) {
            setFormError(processSummary.email.invalidEmailError);
            return;
        }
    };

    return (
        <Input
            label={processSummary.email.yourEmail}
            sublabel={processSummary.email.subLabel}
            value={emailInputValue}
            type="email"
            inputMode="email"
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            error={formError}
            data-testid="email-input"
            required
            id="email-input"
            className="email-input"
        />
    );
};
